import React from "react";
import ReactECharts from "echarts-for-react";

const TrendChart = ({ trendChartOption, loading }) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-800">
            All three segments - monthly cumulative trend (Rs Cr)
          </h2>
          <p className="text-sm text-slate-400 font-semibold">
            Factory total - Onshore total - Service total across available
            months
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4 text-sm font-bold">
          {[
            { label: "Factory", color: "#4361ee" },
            { label: "Onshore", color: "#2a9d90" },
            { label: "Service", color: "#6d4cf5" },
          ].map((legend) => (
            <div
              key={legend.label}
              className="inline-flex items-center gap-2 text-slate-500"
            >
              <span
                className="h-2.5 w-2.5 rounded-sm"
                style={{ backgroundColor: legend.color }}
              />
              {legend.label}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4 overflow-x-auto">
        <div className="min-w-[900px]">
          <ReactECharts
            option={trendChartOption}
            notMerge
            lazyUpdate
            showLoading={loading}
            style={{ height: 320, width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default TrendChart;
